// Pro-Op Industries — the FRONTEND face of the client config seam. The '@client/config'
// vite alias resolves here in this fork (web/vite.config.js repoint — the
// fork's one sanctioned edit outside client-custom/).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js (the
// server face). The config suite asserts the two never drift — edit BOTH
// or the runner goes RED.

export const BRAND_NAME = 'Pro-Op Industries';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'Pro-Op Industries — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see the
// server-side config). Mirrors client.config.js; the config suite checks.
export const SITE_SWITCH_GROUP = 'site-switchers';
export const STORAGE_PREFIX = 'pro-op-industries';

export const PROJECT_ISSUE_TYPE = 'Project';
export const MODULE_ISSUE_TYPE = 'Module';
export const LINK_TYPE_NAME = 'Hierarchy';

export const WPO_FIELD = 'customfield_10001';

export const ACCENT_RGB = { r: 245, g: 163, b: 0 };

export const CUSTOMS_ALLOWED_HOSTS = [];
